const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20a%20single%20spotlight%20on%20an%20empty%20stage%2C%20mysterious%20atmosphere%2C%20warm%20amber%20and%20red%20accents%2C%20film%20noir%20cinematic%20style%2C%20deep%20shadows%2C%20theatrical%20composition%2C%20anticipation%20and%20drama&width=1200&height=600&seq=carousel-01-2026&orientation=landscape',
    tag: '深度专题',
    title: '娱乐圈塌房简史：从顶流到查无此人的180天',
    desc: '盘点近三年娱乐圈最轰动的塌房事件，分析从负面爆料爆发到艺人全面消失的全过程，揭示娱乐资本运作背后的残酷逻辑。',
    date: '2026.07.28',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20boardroom%20with%20empty%20chairs%20around%20a%20long%20table%2C%20dramatic%20overhead%20lighting%2C%20mysterious%20atmosphere%2C%20warm%20red%20accents%2C%20film%20noir%20style%2C%20deep%20shadows%2C%20power%20struggle%20vibe&width=1200&height=600&seq=carousel-02-2026&orientation=landscape',
    tag: '深度调查',
    title: '网红产业链大起底：MCN 如何批量制造与毁灭网红',
    desc: '深入调查国内头部 MCN 机构的运营模式，揭秘网红签约、包装、变现与解约全流程中的灰色地带与行业内幕。',
    date: '2026.07.25',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20server%20room%20with%20blinking%20red%20lights%2C%20dramatic%20moody%20lighting%2C%20mysterious%20cyber%20atmosphere%2C%20golden%20amber%20accents%2C%20film%20noir%20style%2C%20deep%20shadows%2C%20data%20breach%20vibe&width=1200&height=600&seq=carousel-03-2026&orientation=landscape',
    tag: '独家报道',
    title: '数据泄露黑市：你的个人信息正在被明码标价交易',
    desc: '暗网吃瓜独家调查国内个人信息黑市交易链，揭露从企业数据泄露到黑市流转再到精准诈骗的完整犯罪链条。',
    date: '2026.07.22',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20sports%20stadium%20interior%20empty%20at%20night%20with%20dramatic%20stadium%20lighting%2C%20mysterious%20atmosphere%2C%20warm%20amber%20and%20red%20accents%2C%20film%20noir%20cinematic%20style%2C%20deep%20shadows%2C%20competition%20drama%20vibe&width=1200&height=600&seq=carousel-04-2026&orientation=landscape',
    tag: '长篇特写',
    title: '竞技体育的暗面：从假球到兴奋剂的隐秘世界',
    desc: '多位退役运动员与业内人士独家讲述竞技体育中不为人知的黑暗面，包括假球操控、兴奋剂滥用与裁判腐败内幕。',
    date: '2026.07.20',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20luxury%20apartment%20interior%20with%20scattered%20money%20and%20documents%2C%20dramatic%20moody%20lighting%2C%20mysterious%20atmosphere%2C%20warm%20red%20and%20golden%20amber%20accents%2C%20film%20noir%20style%2C%20deep%20shadows%2C%20corruption%20expose%20vibe&width=1200&height=600&seq=carousel-05-2026&orientation=landscape',
    tag: '年度盘点',
    title: '贪腐风云录：2025-2026年度反腐重大案件全记录',
    desc: '系统梳理近一年来国内最引人关注的反腐案件，从商业贿赂到官员落马，还原案件来龙去脉与背后利益网络。',
    date: '2026.07.18',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            深度专题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            暗网吃瓜编辑团队出品的深度调查与长篇专题报道，带你走进事件背后
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-4">
          {carouselItems.slice(0, 1).map((item, i) => (
            <article
              key={i}
              className="lg:w-1/2 group bg-background-200/80 border border-background-300/30 rounded-xl overflow-hidden hover:border-primary-500/20 transition-all cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-200/90 via-background-200/30 to-transparent"></div>
                <span className="absolute top-4 left-4 text-[10px] px-2.5 py-1 rounded bg-primary-500/80 text-background-50">
                  {item.tag}
                </span>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-lg md:text-xl font-heading text-foreground-950 mb-2 group-hover:text-primary-400 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 line-clamp-2">{item.desc}</p>
                </div>
              </div>
            </article>
          ))}
          <div className="lg:w-1/2 flex flex-col gap-4">
            {carouselItems.slice(1, 3).map((item, i) => (
              <article
                key={i + 1}
                className="group bg-background-200/80 border border-background-300/30 rounded-xl overflow-hidden hover:border-primary-500/20 transition-all cursor-pointer flex flex-col sm:flex-row"
              >
                <div className="relative sm:w-2/5 aspect-video sm:aspect-auto overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <span className="absolute top-3 left-3 text-[10px] px-2 py-0.5 rounded bg-accent-500/80 text-background-50">
                    {item.tag}
                  </span>
                </div>
                <div className="flex-1 p-4 flex flex-col justify-center">
                  <h3 className="text-sm font-medium text-foreground-800 mb-1 group-hover:text-primary-400 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-2">{item.desc}</p>
                  <span className="text-xs text-foreground-500">{item.date}</span>
                </div>
              </article>
            ))}
            {carouselItems.slice(3).map((item, i) => (
              <article
                key={i + 3}
                className="group bg-background-200/80 border border-background-300/30 rounded-xl overflow-hidden hover:border-primary-500/20 transition-all cursor-pointer flex flex-col sm:flex-row"
              >
                <div className="relative sm:w-2/5 aspect-video sm:aspect-auto overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <span className="absolute top-3 left-3 text-[10px] px-2 py-0.5 rounded bg-secondary-500/80 text-background-50">
                    {item.tag}
                  </span>
                </div>
                <div className="flex-1 p-4 flex flex-col justify-center">
                  <h3 className="text-sm font-medium text-foreground-800 mb-1 group-hover:text-primary-400 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-2">{item.desc}</p>
                  <span className="text-xs text-foreground-500">{item.date}</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}